// removed by extract-text-webpack-plugin
module.exports = {"header":"IBP3rP2M8WpIZ7dDEm7Ie","subtitle":"_1_C3v1P9y_5f_puWez1p89","title":"_3-yRC9f0rHaI0xySGGLjIK","titleContainer":"_2xWeE8ea2F4fzX68hOD0LP","titleGroup":"SQssgOAYCsr0dQFQoYeO9","body":"_3yYT3Q9uc_EjSK_U8fL10W"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/TableSection.module.css
// module id = 2350
// module chunks = 1